import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';

const AuthTabs = ({ activeTab, onTabChange }) => {
  const { t } = useLanguage();

  const tabs = [
    { id: 'login', label: t('signIn') },
    { id: 'signup', label: t('signUp') }
  ];

  return (
    <div className="flex gap-2 p-1 bg-muted rounded-lg mb-6 md:mb-8">
      {tabs?.map((tab) => (
        <button
          key={tab?.id}
          onClick={() => onTabChange(tab?.id)}
          className={`flex-1 px-4 py-2.5 md:py-3 text-sm md:text-base font-medium rounded-md transition-all ${
            activeTab === tab?.id
              ? 'bg-card text-foreground shadow-elevation-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          {tab?.label}
        </button>
      ))}
    </div>
  );
};

export default AuthTabs;